import React from 'react';
import { motion } from 'framer-motion';
import { inputs, inputsOct, octVariables } from '../../data/teaser';
interface InputsScreenProps {
  onAdvance: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function InputsScreen({
  onAdvance
}: InputsScreenProps) {
  return <div className="flex flex-1 flex-col" data-id="element-105" data-mp="3lu158jeukucr">
      <motion.h2 initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      ease: EASE
    }} className="font-display text-[28px] font-bold uppercase leading-[0.98] tracking-tight text-navy" data-id="element-106" data-mp="3lszqo4ymhpqa">
        {inputs.headline[0]}
        <span className="mt-1 block text-blue" data-id="element-107" data-mp="2xxdiqcyfmru7">{inputs.headline[1]}</span>
      </motion.h2>

      <div className="mt-5 flex items-center gap-1.5" data-id="element-108" data-mp="32wggdcc31vs5">
        {octVariables.map((v, i) => <motion.button key={v} type="button" onClick={onAdvance} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.22,
        delay: 0.06 + i * 0.05,
        ease: EASE
      }} className="h-9 flex-1 rounded-lg border border-line bg-mist font-display text-[12px] font-semibold tracking-tight text-navy2 transition-colors duration-150 hover:border-blue hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-109" data-mp="w4pb7rer9i8m" data-mpi={i}>
            {v}
          </motion.button>)}
      </div>

      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.28,
      delay: 0.12,
      ease: EASE
    }} className="mt-4 overflow-hidden rounded-xl border border-line" data-id="element-110" data-mp="87r9bmrljbb4">
        <div className="flex h-[210px] items-center justify-center bg-[#0A0F14]" data-id="element-111" data-mp="i32rkf27r0nm">
          <img src={inputsOct.src} alt={inputsOct.alt} draggable={false} className="max-h-full w-full select-none object-contain" data-id="element-112" data-mp="d4hsiiyp6n0r" />
        </div>
        <figcaption className="border-t border-line bg-mist px-3 py-1.5 text-[9px] uppercase tracking-micro text-mut" data-id="element-113" data-mp="1okzneemnchla">
          {inputsOct.caption}
        </figcaption>
      </motion.figure>

      <p className="mt-4 text-[13px] leading-relaxed text-navy" data-id="element-114" data-mp="20lxxbwajghxb">{inputs.support}</p>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.4,
      ease: EASE
    }} className="mt-auto pt-4 font-display text-[19px] leading-snug text-blue" data-id="element-115" data-mp="25nx29alxfmwd">
        {inputs.transition}
      </motion.p>
    </div>;
}